/**
 * Die Marke an einem Lieferanten-Suchtreffer: "inaktiv" bzw. "Status unbekannt" - und bei einem
 * aktiven Lieferanten NICHTS (`null`).
 *
 * ============================== EINE FUNKTION, KEINE KOMPONENTE ==============================
 *
 * Und das ist der Kern, nicht Geschmack: `aktivMarke(...)` LIEFERT `null`, waehrend ein
 * `<AktivMarke />` immer ein wahrheitswertiges React-Element ist - dass es intern `null` rendert,
 * sieht der Aufrufer nicht. `JtlSuchfeld` entscheidet aber am Rueckgabewert von `zusatz`, ob es
 * ueberhaupt eine Huelle zeichnet ("`null` heisst kein Zusatz an DIESEM Treffer"). Als Komponente
 * gebaut, stand deshalb an JEDEM aktiven Treffer der Anlagemaske eine leere `<span class="mono">` -
 * die Randspalte aus lauter Nichts, die dieses Bauteil ausdruecklich vermeiden soll. Beim
 * Selbstdurchgang am 2026-08-13 gefunden, gedeckt durch `verdrahtungAnlage.test.tsx`, Fall (b2)
 * ("leere Randspalte am aktiven Treffer").
 *
 * Ohne Haken (`useState`/`useEffect`/...) ist der direkte Aufruf einer solchen Funktion vollkommen
 * regulaer - React sieht davon nichts, es bekommt nur den fertigen Knoten.
 *
 * ============================== WARUM EIN AKTIVER TREFFER LEER BLEIBT ==============================
 *
 * Eine Trefferliste ist eine Liste, kein Datenblatt: markiert wird die AUSNAHME. Stuende an jedem
 * aktiven Treffer "aktiv", traege jede Zeile eine Marke, und genau dadurch faellt keine mehr auf -
 * die Kennzeichnung haette ihren Zweck verfehlt.
 *
 * Der unbekannte Zustand bekommt aus demselben Grund seine EIGENE Marke und nicht etwa gar keine:
 * bliebe er leer, hiesse "keine Marke" fuer den Bediener "aktiv", und ein Lieferant mit unbekanntem
 * Zustand saehe aus wie ein einwandfreier. Das ist dieselbe plausible Unwahrheit, wegen der
 * `pilleAusAktiv` in der Kopfkarte am 2026-08-13 repariert werden musste.
 *
 * ZWEI AUFRUFER, EIN BAUTEIL: die Lieferantenflaeche (`LieferantenSeite.tsx`) und die Anlagemaske
 * (`NewOrder/Anlagemaske.tsx`). Zwei Abschriften desselben Markups liefen frueher oder spaeter
 * auseinander - und ausgerechnet die Anlagemaske, wo die Angabe am meisten zaehlt, waere die
 * Stelle, an der es niemandem auffiele.
 */
import type { JSX } from "react";
import { AKTIV_BESCHRIFTUNG, aktivZustand } from "../../lib/jtlAktiv.ts";

/**
 * `aktiv` ist der ROHE Wert des Treffers (`JtlAktiv`) - eingeordnet wird hier, nicht beim Aufrufer.
 * `null` heisst "an diesem Treffer ist nichts zu melden".
 */
export function aktivMarke(aktiv: unknown): JSX.Element | null {
  const zustand = aktivZustand(aktiv);
  if (zustand === "aktiv") return null;
  return <span className={`jtl-treffer-marke ${zustand}`}>{AKTIV_BESCHRIFTUNG[zustand]}</span>;
}
